import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

import { useNavigate } from "react-router";
import { useAppDispatch } from "../../../../hooks/hooks";
import { selectGlobalLogisticsCatalogListItems } from "../../../../redux/global-logistics/selector";
import storePersist from "../../../../redux/storePersist";
import { globalLogisticsCatalog } from "../../../../redux/global-logistics/action";
import PageLoader from "../../../../components/PageLoader";
import Table from "../../../../common/components/table";



const GlobalLogisticInfoComponent = () => {
      const [storedItems, setStoredItems] = useState<any>({});
  useEffect(() => {
      const storedValue = localStorage.getItem('storageKey');
      if (storedValue) {
          try {
              const parsedValue = JSON.parse(storedValue);
              setStoredItems(parsedValue.items || []);
          } catch (error) {
              console.error("Error parsing JSON from localStorage:", error);
          }
      } else {
          console.log("No stored value found");
      }
  }, []);
    const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
    const navigate = useNavigate()
    const globalLogisticsCatalogItems = useSelector(selectGlobalLogisticsCatalogListItems)
    var tenantId = storePersist?.get("guestTokenMetadata")?.current?.result?.TokenMetadata?.TenantId;
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
   
      
        const createColumnDefs: any = () => {
  setColumnDefs([
    {
      field: 'Sl',
      headerName: 'Sl',
      sortable: false,
      filter: false,
      isSortLabel: true,
      cellRenderer(params: any) {
        return parseInt(params.node.id, 10) + 1;
      },
    },
    {
      field: 'ShippingProviderName',
      headerName: 'Shipping Provider Name',
      sortable: true,
      filter: true,
    },
    {
      field: 'IsInternalProvider',
      headerName: 'Is Internal Provider',
      sortable: true,
      cellRenderer: 'yesNoRenderer'
    },
    {
      field: 'DBNIEName',
      headerName: 'DBNIE Name',
      sortable: true,
      filter: true,
    },
    {
      field: 'DBNPName',
      headerName: 'DBNP Name',
      sortable: true,
      filter: true,
    },
    {
      field: 'ProviderName',
      headerName: 'Provider Name',
      sortable: true,
      filter: true,
    },
    {
      field: 'DBNPRegistryName',
      headerName: 'DBNP Registry Name',
      sortable: true,
      filter: true,
    },
    {
      field: 'GlobalOrgRegistryName',
      headerName: 'Global Org Registry Name',
      sortable: true,
      filter: true,
    },
  ]);
};

      const fetchGlobalLogisticsCatalog=()=>{
        dispatch(globalLogisticsCatalog.list({url:`https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.2/logistics/transport/global-logistics-catalogs/fetch`,entity:'globalLogisticsCatalog',jsonData:{
           "Context": {},
                "Records": [
                    {
                        "IsDBNBased":  true,
                 "DBNPId": storedItems?.DBNPId ?? 0
                    }
  ]
        }}))
      }
      useEffect(() => {
        console.log("Fetched policyItems:", globalLogisticsCatalogItems);
      }, [globalLogisticsCatalogItems]);
     const formatRowData = () => {
  const record = globalLogisticsCatalogItems?.result?.items;

  if (!record || !Array.isArray(record.Providers)) return [];

  return record.Providers.map((provider: any) => ({
    ShippingProviderId: provider?.LSPDescriptor?.ShippingProviderId || 0,
    ShippingProviderName: provider?.LSPDescriptor?.ShippingProviderName || "",
    IsInternalProvider: provider?.LSPDescriptor?.IsInternalProvider || false,

    // NEW FIELDS BASED ON UPDATED API
    DBNPName: record.DBNPName || "",
    ProviderName: provider?.ProviderName || "",
    DBNPRegistryName: record?.DBNPRegistryId || "",
    GlobalOrgRegistryName: record?.GlobalDBNPRegistryId || "",
  }));
};
      
      
      const handleSearch = (data: any) => {
        console.log('Search data', data)
        let searchCriteria = {};
        if (data?.column){
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
    
        dispatch(globalLogisticsCatalog.list({url:`https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.2/logistics/transport/global-logistics-catalogs/fetch`,entity:'globalLogisticsCatalog',jsonData:{
      
            "Context": {},
            "Records": [
                {
                  "IsDBNBased":  true,
                    "DBNPId": storedItems?.DBNPId ?? 0
                 
                }
]
      
          }}))
      }
    //  const handlePublishGlobalLogisticCatalog = async () => {
    //     await dispatch(globalLogisticsCatalog.resetAction({ actionType: 'create' }))
    //     await dispatch(globalLogisticsCatalog.create({
    //       url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.2/logistics/transport/global-logistics-catalogs/publish`,
    //       entity: 'globalLogisticsCatalog',
    //       jsonData:
    //       {
    //         "Context": {},
    //         "Records": [
    //           { "TenantId": tenantId}
    //         ]
    //       }
    //     })).then(() => {
    //       fetchGlobalLogisticsCatalog();
    //     });
    //   }

      const handleEdit = (data: any) => {
        navigate(`/dbn/global-dbnp-registrations/global-logistics-catalog/${data?.ShippingProviderId}`)
      }
     
	useEffect(() => {
    if(storedItems?.Id){
        createColumnDefs()
        fetchGlobalLogisticsCatalog()
    }
	}, [pageData,pageSize,storedItems])
  
    return (
    <>
    {globalLogisticsCatalogItems?.isLoading ?  <PageLoader />: 
        <Table columnData={columnDefs}
    onSearch={handleSearch} rowData={formatRowData()} setPageData={setPageData}
    paginationData={globalLogisticsCatalogItems?.result?.pagination}onEdit={handleEdit}
     setPageSize={setPageSize}headingName="Global Logistics Catalog"/>
     
  }
  </> 
    );
};

export default GlobalLogisticInfoComponent;


